module.exports = __webpack_public_path__ + "media/pressalit_4.75eb9de6.mp4";